export const isZoover = process.env.NEXT_PUBLIC_BRAND === 'ZVRNL';
export const isVakanties = process.env.NEXT_PUBLIC_BRAND === 'VAKNL';
